import { partialWordMatch } from '@/functions/utility.js'

export default {
  // namespaced: true,
  state: {
    query: '',
    users: [],
    rooms: [],
    highlightedRoom: '',
    highlightedUser: '',
    isLoaded: false,
    debounceTimeout: 0,
  },

  getters: {
    query: state => state.query,
    users: state => state.users,
    rooms: state => state.rooms,
    highlightedRoom: state => state.highlightedRoom,
    highlightedUser: state => state.highlightedUser,
    isLoaded: state => state.isLoaded,
    placeholder(_s, _g, _rs, rootGetters){
      return rootGetters['routing/routeName'] === 'area' ? 'People and Rooms' : 'guests to Room'
    },
  },

  mutations: {
    HIGHLIGHTED_ROOM: (state, data) => state.highlightedRoom = data,
    HIGHLIGHTED_USER: (state, data) => state.highlightedUser = data,
    IS_LOADED: (state, data) => state.isLoaded = data,
  },

  actions: {
    doSearch({dispatch, state, rootGetters}, query){
      if(query !== undefined) query = state.query = query.trim() || ''
      else query = state.query
      dispatch('clear', false)

      if(!query) return

      state.debounceTimeout = setTimeout(async() => {
        let res = await dispatch('api/search/usersInArea', query, {root:true})
        if(!res?.success) dispatch('popups/show/error/custom', 'searching', {root: true})

        // if the request comes back after the user has changed their input, then the request is stale, and should be discarded
        if(query !== state.query) return

        if(!res?.success) return

        state.users = res.success.results
        if(rootGetters['routing/routeName'] === 'area') state.rooms = rootGetters.getSpaces.filter(room => partialWordMatch(room.name, query))
        state.isLoaded = true
      }, 300)
    },
    clear({state}, clearQuery = true) {
      if(clearQuery) state.query = ''

      clearTimeout(state.debounceTimeout)
      state.highlightedRoom = ''
      state.highlightedUser = ''
      state.isLoaded = false
      state.users = []
      state.rooms = []
    },
    load: ({commit}) => commit('IS_LOADED', true),
    unload: ({commit}) => commit('IS_LOADED', false),
  }
}
